import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import { Row, Col, Modal, Button } from 'react-bootstrap'
import parse from 'html-react-parser';

class ExamInstructionModal extends Component {
    render() {

        let instructions = this.props.examInstructions;

        return (
            <Modal
                className="result-modal-custom"
                {...this.props}
                centered
                size="lg"
                aria-labelledby="example-modal-sizes-title-md"
            >

                {/* GREEN HEADER WITH CLOSE BUTTON */}
                <div style={{
                    background: "#28a745",
                    padding: "12px 20px",
                    color: "#fff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    fontSize: "18px",
                    fontWeight: "bold"
                }}>
                    Exam Instructions

                    {/* Close Button inside header */}
                    <Button
                        variant="link"
                        className="text-white p-0"
                        style={{
                            fontSize: "20px",
                            lineHeight: "20px",
                            textDecoration: "none"
                        }}
                        onClick={() => this.props.onHide()}
                    >
                        ×
                    </Button>
                </div>

                <Modal.Body className="pt-3">

                    <Row>
                        <Col
                            xl={{ span: 10, offset: 1 }}
                            lg={{ span: 10, offset: 1 }}
                            md={{ span: 10, offset: 1 }}
                            sm={12}
                        >
                            <h6 className="mb-2">
                                <u>Please read the following instructions carefully.</u>
                            </h6>

                            {instructions !== undefined
                                ? parse(instructions.instructions)
                                : ""}
                        </Col>
                    </Row>

                </Modal.Body>

            </Modal>
        )
    }
}

export default withRouter(ExamInstructionModal);
